var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var defaultMessages = require('../../i18n/messages/default');
var Utils = require('../../utils/Utils.js');
var UrlUtils = require('../../utils/urlUtils');
var { Input, Button } = require('metro-ui-components');
var PropTypes = require('prop-types');
var LoginActions = require('../../actions/LoginActions.js');
var LoginStore = require('../../stores/LoginStore.js');
var ErrorCodes = require('../../utils/ErrorCodes.js');
var ErrorCodesConfigs = require('../../utils/ErrorCodesConfigs.js');
var _ = require('lodash');
var AppConstants = require('../../constants/AppConstants');
var TryOtherWays = require('../LoginPreferences/TryOtherWays.js');
var UserAuthMethods = require('../LoginPreferences/UserAuthMethods.js');
const DOMPurify = require('dompurify');


const MappedMfaOptionsName = {
    "2FA_TOTP_APP": "authMethodDeviceName",
    "2FA_WEB_AUTHN": "authMethodDeviceName",
    "2FA_TOTP": "phone",
}
const userLoginId = (JSON.parse(window.localStorage.getItem('userLoginId')) || UrlUtils.getParameterByName(AppConstants.UrlParams.LOGIN_ID)) || "";
const otpChannel = UrlUtils.getParameterByName(AppConstants.UrlParams.OTP_CHANNEL);

class TOTPWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totpValue: '',
            twoFaAuthMethod: props.twoFaAuthMethod,
            totp_view_options: AppConstants.TOTP_VIEW_OPTIONS[props.twoFaAuthMethod],
            hasErrors: false
        };

        this.selectedTotp = {
            totpType: "",
            totpName: ""
        }

        this.setAuthenticationMethodOnClick= this.setAuthenticationMethodOnClick.bind(this);
    }

    componentDidMount() {
        if (this.state.totp_view_options.resendTotpAllowed) {
            this.onResendTOTP();
        }
        if (this.state.totp_view_options.displayTotpSentMessage) {
            this.displayTotpSentMessage();
        }
        LoginStore.totpValidationListner(this.onTotpValidation.bind(this));
        LoginStore.totpResentListner(this.onTotpResend.bind(this));
        this.setBackToLoginUrl();
    }

    setBackToLoginUrl() {
        let props = this.props;
        let responseModeValue =  UrlUtils.getParameterByName(AppConstants.UrlParams.RESPONSE_MODE);
        const passwordlessPageParams = UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE, props.codeChallenge) + 
        UrlUtils.appendQueryParam(AppConstants.UrlParams.CODE_CHALLENGE_METHOD, props.codeChallengeMethod) +
        UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_MODE, responseModeValue) +
        UrlUtils.appendQueryParam("passwordless", true) ;

        const redirectParams = otpChannel ? passwordlessPageParams : "";
        let backToLoginUrl = window.location.protocol + "//" + window.location.host + AppConstants.Links.SIGN_IN_PAGE + "?" +
            AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, encodeURIComponent(props.redirectUrl)) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.RESPONSE_TYPE, props.responseType) +

            UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.ACCOUNT_ID, props.accountId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, props.localeId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.SCOPE, props.scope) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.NONCE, props.nonce) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
            UrlUtils.appendQueryParam(AppConstants.UrlParams.STATE, props.state) +
            redirectParams;
            
        if(otpChannel){
            this.setState({ backToLoginUrl: backToLoginUrl },function(){ this.sendBackUrl()});
        }else{
            this.setState({ backToLoginUrl: backToLoginUrl });
        }
    }

    onTotpValidation() {
        let appState = LoginStore.getState();

        if (appState.totp.invalidMailToken) {
            window.location = this.state.backToLoginUrl +
                UrlUtils.appendQueryParam("emailSent", AppConstants.EmailSentCode.VALIDATETOTPERROR)
            return;
        }

        if (appState.totp.isValid) {
            if (this.props.isForgotPasswordFlow) {
                const props = this.props;
                let resetpwdurl = window.location.protocol + "//" + window.location.host + AppConstants.Links.RESET_PASSWORD_PAGE + this.props.idToken + "?" +
                    AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, props.localeId) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId)

                window.location.replace(resetpwdurl);
            }
            else
                //check whether request is from normal TOTP page or directTOTP landing page
                (appState.AuthCode && appState.AuthCode.redirecturi) ?
                    window.location.replace(appState.AuthCode.redirecturi) :
                    window.location.replace(this.props.directOtpRedirectUri);
            return;
        }

        var errorIndex = _.findIndex(ErrorCodesConfigs.TOTPErrorCodes, function (o) { return o == appState.totp.errorCode; });

        if (this.props.isForgotPasswordFlow && errorIndex == -1 && appState.totp.errorCode != AppConstants.GENERIC_ERROR_CODE) {
            LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages['reset.password.totp.invalid']), appState.totp.placeholders), "error")
        }
        else {
            LoginActions.triggerToast(Utils.replaceAllByKeys(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.totp.errorCode]]), appState.totp.placeholders), "error")
        }
    }

    onTotpResend() {
        let appState = LoginStore.getState();
        if (appState.totp.totpResent) {
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[appState.totp.errorCode]), "success", true);
            return;
        }
        LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[appState.totp.errorCode]), "error");
    }

    getMappedUserMfaOption(defaultMethod) {
        let defaultMfaOptionType = "";
        let defaultMfaOptionName = "";
        if(defaultMethod.length) {
            defaultMfaOptionType = defaultMethod[0].mfaOptionType;
            defaultMfaOptionName = defaultMethod[0].name;
        }

        return { defaultMfaOptionType, defaultMfaOptionName }
    }

    onResendTOTP(evt, userRequested = false) {
        const {totpType, totpName} = this.selectedTotp;
        evt && evt.preventDefault && evt.preventDefault();

        if(otpChannel){
            let isClientPasswordless= UrlUtils.getParameterByName("passwordless") === 'true';

            let keysToReplaced = {
                '<otp_method>':  this.obscureData(userLoginId) || '',
            };
            let messageToaster = Utils.replaceAllByKeys(
                this.props.intl.formatMessage(defaultMessages['validateOtpSentSuccessfully']), keysToReplaced
            )
      
            LoginActions.generateOtpCode(userLoginId, isClientPasswordless, this.props.userType, this.props.clientId, this.props.responseType,
                this.props.countryCode,this.props.localeId, this.props.realmId, this.props.accountId, this.props.redirectUrl, this.props.state,
                this.props.prompt, this.props.nonce,this.props.scope, this.props.traceId, this.props.codeChallenge,
                this.props.codeChallengeMethod);
                
            let appState = LoginStore.getState();
            if(appState.genOtpHasError){
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages["otpResendError"]),"error");
            }else{
                LoginActions.triggerToast(this.highlightUserID(messageToaster), "success", true);
            }
                
        return
        }
        if (!totpName) {
            const defaultMethod = this.props.userMFAMethods.filter((method) => method.authenticationMethod === this.props.twoFaAuthMethod && method.name === this.props[MappedMfaOptionsName[this.props.twoFaAuthMethod]]);
            const { defaultMfaOptionType, defaultMfaOptionName } = this.getMappedUserMfaOption(defaultMethod);

            LoginActions.resendTOTP(this.props.login, this.props.traceId, this.props.idToken, this.props.realmId, this.props.countryCode, this.props.userType, defaultMfaOptionType, defaultMfaOptionName, userRequested);
        } else {
            LoginActions.resendTOTP(this.props.login, this.props.traceId, this.props.idToken, this.props.realmId, this.props.countryCode, this.props.userType, totpType, totpName, userRequested);
        }
    }

    displayTotpSentMessage(evt) {
        evt && evt.preventDefault && evt.preventDefault();
        const keysToReplaced = {
            '<otp_method>':  this.obscureData(userLoginId) || '',
        };
        const messageToaster = Utils.replaceAllByKeys(
            this.props.intl.formatMessage(defaultMessages['validateOtpSentSuccessfully']), keysToReplaced
        )
        if(otpChannel){
            LoginActions.triggerToast(this.highlightUserID(messageToaster), "success", true);
        }else{
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['totp_sent_successfully']), "success", true);
        }
    }

    onTOTPChange(e, value) {
        this.setState({ totpValue: value });
        this.totp = value;
    }

    onTOTPSubmit(evt) {
        const { totpType, totpName } = this.selectedTotp;
        evt && evt.preventDefault && evt.preventDefault();

        if(otpChannel){
            let appState = LoginStore.getState();
            LoginActions.validateOtpAuth(userLoginId, this.props.userType, this.totp , this.props.countryCode, this.props.clientId);

            if(appState.otp.error){
                this.setState({hasErrors: true})
                LoginActions.triggerToast(appState.otp.message, "error")
                return
            }
        } else if (this.props.isForgotPasswordFlow)
            LoginActions.submitTOTPForgotPassword(this.totp, this.props.idToken, this.props.login, this.props.countryCode, this.props.realmId, this.props.userType, this.props.traceId);
        else {
            let appState = LoginStore.getState();
            const defaultMethod = this.props.userMFAMethods.filter((method) => method.authenticationMethod === this.props.twoFaAuthMethod && method.name === this.props[MappedMfaOptionsName[this.props.twoFaAuthMethod]]);
            const { defaultMfaOptionType, defaultMfaOptionName } = this.getMappedUserMfaOption(defaultMethod);
    
            let startSessionIdentifier = (appState.AuthCode && appState.AuthCode.redirecturi) ? UrlUtils.getParameterByName("start_session_id", appState.AuthCode.redirecturi) : UrlUtils.getParameterByName("start_session_id", window.location.href);
            if (startSessionIdentifier)
                LoginActions.submitTOTPWithSession(this.totp, this.props.idToken, this.props.login, this.props.countryCode, this.props.realmId, this.props.userType, this.props.traceId, startSessionIdentifier, totpType || defaultMfaOptionType, totpName || defaultMfaOptionName);
            else
                LoginActions.submitTOTP(this.totp, this.props.idToken, this.props.login, this.props.countryCode, this.props.realmId, this.props.userType, this.props.traceId);

        }
    }

    onBackToLogin(evt) {
        UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
        window.location = this.state.backToLoginUrl;
    }

    sendBackUrl(){
        UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
        this.props.backArrowLink(this.state.backToLoginUrl)
    }

    setAuthenticationMethodOnClick(authMethodItem) {
        this.props.setAuthenticationMethodOnClick(authMethodItem);
        this.selectedTotp = {
            totpType: authMethodItem.mfaOptionType,
            totpName: authMethodItem.name
        };
        this.setState({totp_view_options: AppConstants.TOTP_VIEW_OPTIONS[authMethodItem.authenticationMethod]});
        const totp_view_options = AppConstants.TOTP_VIEW_OPTIONS[authMethodItem.authenticationMethod];
        if(totp_view_options.resendTotpAllowed) {
            this.onResendTOTP();
        }
        if(totp_view_options.displayTotpSentMessage) {
            this.displayTotpSentMessage();
        }
    }

    renderMFAMethods() {
        return (
            <UserAuthMethods 
                {... this.props}
                phone={this.props.phone}
                emailId={this.props.emailId}
                login={this.props.login}
                idToken={this.props.idToken}
                userId={this.props.userId}
                directOtpRedirectUri={this.props.directOtpRedirectUri}
                showMFAMethods= {this.props.showMFAMethods}
                showMFAMethodsBox= {this.props.showMFAMethodsBox}
                twoFaAuthMethod= {this.props.twoFaAuthMethod}
                authMethodDeviceName= {this.props.authMethodDeviceName}
                setAuthenticationMethodOnClick= {this.setAuthenticationMethodOnClick}
                userMFAMethods= {this.props.userMFAMethods}/>
        );
    }

    obscureData(initialString){
        if(!initialString){ 
            return initialString;
        }
        const initialLength = initialString.length;

        //return initial string if it's length is smaller then 4, because the string is too small to obscure
        if(initialLength < 4){ 
            return initialString;
        }

        let newString = "";
        const sliceThreshold= Math.floor(initialLength/3);
        const subStrReplacedLength = initialString.slice(sliceThreshold,initialLength-(sliceThreshold-1)).length;
        const newStrStart = initialString.slice(0,sliceThreshold);
        const newStrReplaced = "*".repeat(subStrReplacedLength);
        const newStrEnd = initialString.slice(initialLength-(sliceThreshold-1),initialLength);
        newString = newString.concat(newStrStart,newStrReplaced,newStrEnd);
        return newString;
    }

    highlightUserID(displayedText){
        if(!displayedText.includes("**")){
          return displayedText;
        }
        const initialStr = displayedText.split(" ");
        const obscuredPosition = initialStr.map(el => el.includes("**")).indexOf(true)
        let lastPart = " ",
            firstPart = "";

        for(let i=0; i< obscuredPosition;i++){
            firstPart = firstPart + initialStr[i] + " ";
        }

        for(let j=obscuredPosition+1; j<= initialStr.length-1;j++){
            lastPart = lastPart + initialStr[j] + " ";
        }

        return(
            <>
                {firstPart} 
                <strong>
                    {initialStr[obscuredPosition]}
                </strong>
                {lastPart} 
            </>
        );
    }

    splitString(termsText) {
        const regex = /(\[.*?\])/g;
        const parts = termsText.split(regex);
        
        const finalArray = [];
    
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].startsWith('[') && parts[i].endsWith(']')) {
                const regex2 = /\[(.*?)\|(.*?)\]/g;
                const [_, text, link] = regex2.exec(parts[i]);
                finalArray.push({ text, link }); 
            } else if (parts[i] !== '') { 
                finalArray.push(parts[i]);
            } 
        }

        const textBuilder = finalArray.map((item, index) => {
            if (typeof item === "object") {
                return <a key={index} href={item.link}>{item.text}</a> }
            else {
                return (<>{item}</>)
                }
            });

        return (
            <div className="privacy-terms-text">
                <p>{textBuilder}</p>
            </div>
        )
    }

    renderValidateOTp(){
        const keysToReplace = {
            '<mobileNum>':  this.obscureData(userLoginId),
            '<emailId>': this.obscureData(userLoginId),
        };
        let sanitizedOtpChannel = DOMPurify.sanitize(otpChannel);
        const brandIdentifier = window.location.hostname.includes("makro") ? "makro" : "metro";
        let sanitizedBrandIdentifier = DOMPurify.sanitize(brandIdentifier);
        let imgSrc = `assets/images/${sanitizedOtpChannel}-${sanitizedBrandIdentifier}-confirmed.svg`;
        imgSrc = DOMPurify.sanitize(imgSrc);
        let validateOtpMsgPhone = this.props.intl.formatMessage(defaultMessages['validateOtpTextPhone']);
        let validateOtpMsgEmail = this.props.intl.formatMessage(defaultMessages['validateOtpTextEmail']);
        let otpHeaderMsg = this.props.intl.formatMessage(defaultMessages['validateOtpTxtHeader']);
        const textPage = Utils.replaceAllByKeys(
            otpChannel === "email" ? validateOtpMsgEmail : validateOtpMsgPhone,
            keysToReplace
        );
        return (
            <div className='otp-content'>
                <p className='otp-content-header'>{otpHeaderMsg}</p>
                <div className='otp-content-container'>
                    <p className='otp-content-text'>
                        {this.highlightUserID(textPage)}
                    </p>
                    <img className={`iconResolution img-responsive img-otp-${sanitizedOtpChannel} ${sanitizedBrandIdentifier}`} id='otp-type'  alt='otp-type' src={imgSrc}/>
                </div>
            </div>
        );
    }

    renderTOTPWidget() {
        const keysToReplace = {
            '<mobileNum>': this.selectedTotp.totpName || this.obscureData(this.props.phone),
            '<emailId>': this.props.emailId || ''
        };
        var totp_view_options = this.state.totp_view_options;
        var headerMessage = this.props.intl.formatMessage(defaultMessages[totp_view_options.headerMessageKey]);
        let privacyAndTerms = this.props.intl.formatMessage(defaultMessages["privacyAndTerms"]);
        let capsLockErrorMessage = this.state.hasErrors ? this.props.intl.formatMessage(defaultMessages["validateOtpError"]) : "";
        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                    <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12 loginFields">
                        <form id="totpForm" onSubmit={this.onTOTPSubmit.bind(this)}>
                            <div className="totp form-group" style={{position: "relative"}}>
                                <label className="control-label form-labels paragraphHeader">
                                        {otpChannel ? this.renderValidateOTp():                                             Utils.replaceAllByKeys(
                                                headerMessage,
                                                keysToReplace
                                        )}
                                </label>
                                <div className="clearfix">
                                    <div className="pull-left otp-passcode">
                                        <b>
                                            {this.props.intl.formatMessage(defaultMessages['enter_totp'])}
                                        </b>
                                    </div>
                                    {(totp_view_options.resendTotpAllowed || otpChannel)  &&
                                        <div className={`pull-right otp-resendcode`}>
                                            <a href="javascript:void(0)" onClick={this.onResendTOTP.bind(this, true)}>
                                                <b>
                                                    {this.props.intl.formatMessage(defaultMessages['resend_totp'])}
                                                </b>
                                            </a>
                                        </div>
                                    }
                                </div>
                                <Input
                                    id="totp"
                                    type="number"
                                    key="totp"
                                    name="totp"
                                    required={true}
                                    value={this.state.totpValue}
                                    onChange={this.onTOTPChange.bind(this)}
                                    autoFocus={true}
                                    hasWarning={this.state.hasErrors}
                                    errorMessage={capsLockErrorMessage}
                                />

                                {!otpChannel &&<Button id="submit" type="submit" kind="primaryRaised" size="large" value="submit" block
                                    disabled={!this.state.totpValue}>
                                    {this.props.intl.formatMessage(defaultMessages['validate_totp_btn'])}
                                </Button> }

                            </div>
                            {otpChannel && this.splitString(privacyAndTerms) }
                            <div className="row opt-row-container">
                                <div className="forgotPasswordLink">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 otp-footer-container">
                                        <div className='otp-link-container'>
                                            <a href="javascript:void(0)" onClick={this.onBackToLogin.bind(this)} className="blue-labels">
                                                {this.props.intl.formatMessage(defaultMessages['backToLogin'])}
                                            </a>
                                        </div>
                                        {otpChannel &&     
                                            <Button className="otp-footer-button" id="submit" type="submit" kind="primaryRaised" size="small" value="submit" block
                                            disabled={!this.state.totpValue}>
                                            {this.props.intl.formatMessage(defaultMessages['submit'])}
                                            </Button>
                                        }
                                    </div>                                 
                                    {
                                    this.props.showTryOtherLink ? 
                                        <div className="pull-right col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <TryOtherWays showMFAMethods= {this.props.showMFAMethods}/>
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>
                </div>
            </div>
        );
    }

    render() {
        return (
            this.props.showMFAMethodsBox? this.renderMFAMethods() : this.renderTOTPWidget()
        );
    }
}

module.exports = injectIntl(TOTPWidget);
